const Cores = {
  colors: {
    primary: '#a7727d',
    secundaria: ' #f9f5e7',
    corTitulo: '#eee'
  }
}
export default Cores
